var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
export {
  COMMENT,
  DECLARATION,
  IMPORT,
  KEYFRAMES,
  LAYER,
  MOZ,
  MS,
  RULESET,
  WEBKIT
};
